import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { PageOutputDto, PageService } from 'src/generated_client';

@Component({
  selector: 'app-app-pages',
  templateUrl: './app-pages.component.html',
  styleUrls: ['./app-pages.component.css']
})
export class AppPagesComponent implements OnInit {

  quillConfiguration = QuillConfiguration;

  pagesForm: FormGroup = this.fb.group({
    about: [''],
    aboutImg: [''],
    how: [''],
    howImg: [''],
    faq: [''],
    contact: [''],
    dsAboutImg: [''],
    dsHowImg: ['']
  })

  pageOutput: PageOutputDto = {} as PageOutputDto;
  cdpage: any;

  constructor(
    private fb: FormBuilder,
    private pageService: PageService,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {

    this.pageService.apiPageGetGet().subscribe(x => {

      this.cdpage = x.cdPage;
      this.SetControls(x);
    });
  }

  private SetControls(x: PageOutputDto) {
    this.pagesForm.controls['about'].setValue(x.dsAboutUs);
    this.pagesForm.controls['dsAboutImg'].setValue(x.dsAboutImg);
    this.pagesForm.controls['how'].setValue(x.dsHow);
    this.pagesForm.controls['dsHowImg'].setValue(x.dsHowImg);
    this.pagesForm.controls['faq'].setValue(x.dsFaq);
    this.pagesForm.controls['contact'].setValue(x.dsContactUs);
  }

  saveChanges(form: any) {
    let imageAbout;
    if (form.aboutImg.length == 0) {
      imageAbout = undefined;
    } else {
      imageAbout = form.aboutImg._files[0]
    }
    let imageHow;
    if (form.howImg.length == 0) {
      imageHow = undefined;
    } else {
      imageHow = form.howImg._files[0]
    }
    this.pageService.apiPagePutPutForm(this.cdpage, form.about, imageAbout, undefined, form.how, imageHow, undefined, form.faq, form.contact, undefined).subscribe(response => {
      this.router.navigate(['admin-home']);
      this.snackBar.openSnackBar('Paginas actualizadas', 'Aceptar');
    },
      err => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse', 'Aceptar')
      }
    );
  }

  get DsAboutImg() {
    return this.pagesForm.controls['dsAboutImg'].value;
  }

  get DsHowImg() {
    return this.pagesForm.controls['dsHowImg'].value;
  }
}

export const QuillConfiguration = {
  toolbar: [
    ['bold', 'underline'],
    [{ 'font': [] }],
    [{ background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }, { 'align': [] }],
    ['link', 'image', 'video'],
    ['code-block'],
    ['clean'],
  ],
}
